"use client"

import { useId } from "react"

type FlagCode = "ja" | "en" | "zh"

interface FlagIconProps {
  code: FlagCode
  className?: string
}

function JapanFlag({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 900 600" className={className}>
      <rect fill="#fff" width="900" height="600" />
      <circle fill="#bc002d" cx="450" cy="300" r="180" />
    </svg>
  )
}

function ChinaFlag({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 900 600" className={className}>
      <rect fill="#de2910" width="900" height="600" />
      <g fill="#ffde00">
        <path d="M 150,150 L 190,230 L 120,180 L 180,180 L 110,230 Z" />
        <path d="M 270,80 L 280,110 L 250,90 L 290,90 L 260,110 Z" />
        <path d="M 310,130 L 320,160 L 290,140 L 330,140 L 300,160 Z" />
        <path d="M 310,210 L 320,180 L 290,200 L 330,200 L 300,180 Z" />
        <path d="M 270,260 L 280,230 L 250,250 L 290,250 L 260,230 Z" />
      </g>
    </svg>
  )
}

function UsaFlag({ className }: { className?: string }) {
  const uid = useId()
  const sId = `${uid}-s`
  const s4Id = `${uid}-s4`
  const s5Id = `${uid}-s5`
  const s9Id = `${uid}-s9`
  const s18Id = `${uid}-s18`

  return (
    <svg viewBox="0 0 7410 3900" className={className}>
      <rect width="7410" height="3900" fill="#b22234" />
      <path d="M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0" stroke="#fff" strokeWidth="300" />
      <rect width="2964" height="2100" fill="#3c3b6e" />
      <g fill="#fff">
        <defs>
          <path id={sId} d="M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z" />
          <g id={s4Id}>
            <use href={`#${sId}`} />
            <use href={`#${sId}`} y="420" />
            <use href={`#${sId}`} y="840" />
            <use href={`#${sId}`} y="1260" />
          </g>
          <g id={s5Id}>
            <use href={`#${s4Id}`} />
            <use href={`#${sId}`} y="1680" />
          </g>
          <g id={s9Id}>
            <use href={`#${s5Id}`} />
            <use href={`#${s4Id}`} x="247" y="210" />
          </g>
          <g id={s18Id}>
            <use href={`#${s9Id}`} />
            <use href={`#${s9Id}`} x="494" />
          </g>
        </defs>
        <use href={`#${s18Id}`} />
        <use href={`#${s18Id}`} x="988" />
        <use href={`#${s9Id}`} x="1976" />
        <use href={`#${s5Id}`} x="2470" />
      </g>
    </svg>
  )
}

export function FlagIcon({ code, className }: FlagIconProps) {
  if (code === "ja") return <JapanFlag className={className} />
  if (code === "zh") return <ChinaFlag className={className} />
  return <UsaFlag className={className} />
}
